import React from 'react';
import classNames from 'classnames';
import {
  ColorStyleProps,
  Icon,
  Text,
  getIcon,
  parseColor,
  useTheme,
} from '@quality24/design-system';
import { ChoiceData } from '@quality24/inpatient-typings';
import { Theme } from '@/inpatient-patient-pwa/types/theme';
import styles from './MultipleChoiceInputField.module.scss';

export interface Props {
  className?: string;
  value: string | undefined;
  onChange: (value: string) => void;
  options: ChoiceData<ColorStyleProps>[];
}

const MultipleChoiceInputField: React.FunctionComponent<Props> = ({
  className,
  value,
  onChange,
  options,
}: Props) => {
  const { theme } = useTheme<Theme>();

  return (
    <div className={classNames(styles.wrapper, className)}>
      {options.map((option) => (
        <button
          key={option.label}
          type="button"
          className={classNames(styles.choice, {
            inactive: value && value !== option.id,
          })}
          onClick={() => onChange(option.id)}
          style={{
            backgroundColor: parseColor(option.backgroundColor ?? 'primary', {
              theme,
            }),
          }}
        >
          {option.icon && (
            <Icon
              icon={getIcon(option.icon)}
              size="md"
              color={option.color || 'white'}
            />
          )}
          {option.label && (
            <Text
              className="flex-1"
              size="md"
              color={option.color || 'white'}
              weight="semiBold"
            >
              {option.label}
            </Text>
          )}
        </button>
      ))}
    </div>
  );
};
export default MultipleChoiceInputField;
